export default "__VITE_ASSET__3tn26Dyy__"